const isValidDateOnly = (value) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const parsed = new Date(`${value}T00:00:00.000Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
};

export const toDateOnlyString = (value) => {
  if (!value) return '';

  if (typeof value?.format === 'function') {
    const formatted = value.format('YYYY-MM-DD');
    return isValidDateOnly(formatted) ? formatted : '';
  }

  if (typeof value === 'string') {
    const candidate = value.slice(0, 10);
    return isValidDateOnly(candidate) ? candidate : '';
  }

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  return '';
};
